export const faMessages = {
  // Global actions and states
  Add: 'افزودن',
  Create: 'ایجاد',
  Edit: 'ویرایش',
  Update: 'به‌روزرسانی',
  Delete: 'حذف',
  Remove: 'حذف',
  Save: 'ذخیره',
  'Save changes': 'ذخیره تغییرات',
  Cancel: 'انصراف',
  Close: 'بستن',
  Confirm: 'تأیید',
  Submit: 'ثبت',
  Continue: 'ادامه',
  Back: 'بازگشت',
  Next: 'بعدی',
  Previous: 'قبلی',
  Search: 'جست‌وجو',
  Filter: 'فیلتر',
  Clear: 'پاک‌کردن',
  'Clear search': 'پاک‌کردن جست‌وجو',
  Reset: 'بازنشانی',
  Refresh: 'تازه‌سازی',
  Retry: 'تلاش مجدد',
  View: 'مشاهده',
  'View details': 'مشاهده جزئیات',
  Details: 'جزئیات',
  Actions: 'عملیات',
  Action: 'عملیات',
  Status: 'وضعیت',
  Type: 'نوع',
  Name: 'نام',
  Code: 'کد',
  Description: 'توضیحات',
  Date: 'تاریخ',
  Time: 'زمان',
  From: 'از',
  To: 'تا',
  Yes: 'بله',
  No: 'خیر',
  All: 'همه',
  None: 'هیچ‌کدام',
  Optional: 'اختیاری',
  Required: 'اجباری',
  Loading: 'در حال بارگذاری',
  'Loading...': 'در حال بارگذاری...',
  'No data': 'داده‌ای وجود ندارد',
  'No records found': 'رکوردی یافت نشد',
  'No results found': 'نتیجه‌ای یافت نشد',
  Success: 'موفق',
  Successful: 'موفق',
  Error: 'خطا',
  Warning: 'هشدار',
  Attention: 'نیازمند توجه',
  Active: 'فعال',
  Inactive: 'غیرفعال',
  Enabled: 'فعال',
  Disabled: 'غیرفعال',
  Enable: 'فعال‌سازی',
  Disable: 'غیرفعال‌سازی',
  Open: 'باز',
  Closed: 'بسته‌شده',
  Pending: 'در انتظار',
  Processing: 'در حال پردازش',
  Completed: 'تکمیل‌شده',
  Complete: 'کامل',
  Confirmed: 'تأییدشده',
  Rejected: 'ردشده',
  Canceled: 'لغوشده',
  Cancelled: 'لغوشده',
  Expired: 'منقضی‌شده',
  Draft: 'پیش‌نویس',
  Paid: 'پرداخت‌شده',
  Unpaid: 'پرداخت‌نشده',
  Settled: 'تسویه‌شده',
  Failed: 'ناموفق',
  Sending: 'در حال ارسال',
  Sent: 'ارسال‌شده',
  Queued: 'در صف',
  Available: 'در دسترس',
  Unassigned: 'تخصیص‌نیافته',
  'Not assigned': 'تخصیص‌نیافته',
  'Not selected': 'انتخاب نشده',
  Included: 'لحاظ‌شده',
  'Not included': 'لحاظ‌نشده',
  Export: 'خروجی',
  Import: 'ورودی',
  Print: 'چاپ',
  Download: 'دانلود',
  Upload: 'بارگذاری',
  Choose: 'انتخاب',
  Copy: 'کپی',

  // Navigation shell
  'Freight operations': 'عملیات حمل بار',
  'Close navigation': 'بستن منو',
  'Search navigation': 'جست‌وجوی منو',
  'Find a page...': 'صفحه موردنظر را پیدا کنید...',
  'Clear navigation search': 'پاک‌کردن جست‌وجوی منو',
  'Main navigation': 'منوی اصلی',
  'No page found': 'صفحه‌ای یافت نشد',
  'Try another name or keyword.': 'نام یا کلیدواژه دیگری وارد کنید.',
  'Open settings': 'بازکردن تنظیمات',
  Settings: 'تنظیمات',
  'Signed-in user': 'کاربر واردشده',
  Administrator: 'مدیر سیستم',
  'Operations team': 'تیم عملیات',
  Main: 'اصلی',
  'Daily work': 'کارهای روزانه',
  'Pickup & delivery': 'دریافت و تحویل',
  'Drivers, pickups and final delivery': 'رانندگان، دریافت و تحویل نهایی',
  'Shipment tools': 'ابزارهای محموله',
  'Tracking, manifests and claims': 'رهگیری، مانیفست و خسارت',
  'Sales & billing': 'فروش و صورتحساب',
  'Customers, pricing and settlement': 'مشتریان، قیمت‌گذاری و تسویه',
  Reports: 'گزارش‌ها',
  'Operational reports': 'گزارش‌های عملیاتی',
  'Shipments, routes and delivery': 'محموله‌ها، مسیرها و تحویل',
  'Business reports': 'گزارش‌های تجاری',
  'Revenue, payments and customers': 'درآمد، پرداخت‌ها و مشتریان',
  'Advanced reports': 'گزارش‌های تکمیلی',
  'Specialized and statistical reports': 'گزارش‌های تخصصی و آماری',
  'System setup': 'تنظیمات سیستم',
  'Network & locations': 'شبکه و مکان‌ها',
  Workspace: 'فضای کاری',
  Dashboard: 'داشبورد',
  'Overview and urgent actions': 'نمای کلی و اقدامات فوری',
  'Step-by-step guide': 'راهنمای قدم‌به‌قدم',
  'Registration to final delivery': 'از ثبت تا تحویل نهایی',
  Shipments: 'محموله‌ها',
  'Courier shipments': 'مرسوله‌های کوریر',
  'Parcels and door-to-door jobs': 'بسته‌ها و مأموریت‌های درب‌به‌درب',
  'Cargo shipments': 'بارهای کارگو',
  'Freight and air cargo jobs': 'حمل بار و عملیات کارگوی هوایی',
  'Bulk tracking': 'رهگیری گروهی',
  'Update several shipments': 'به‌روزرسانی هم‌زمان چند محموله',
  Operations: 'عملیات',
  'Action workbench': 'میز کار اقدام',
  'SLA risks and exceptions': 'ریسک‌های SLA و استثناها',
  'Pending pickups': 'دریافت‌های در انتظار',
  'Pickup requests waiting for action': 'درخواست‌های دریافت منتظر اقدام',
  'Dispatch board': 'تابلوی اعزام',
  'Assign drivers and missions': 'تخصیص راننده و مأموریت',
  'My dispatch': 'اعزام‌های من',
  'Pickup and delivery missions assigned to me': 'مأموریت‌های دریافت و تحویل من',
  'Confirmed COD': 'COD تأییدشده',
  'Finance-approved collection history': 'تاریخچه دریافت‌های تأییدشده مالی',
  'Console manifests': 'مانیفست‌های کنسول',
  'Build and reconcile bags': 'ساخت و تطبیق کیسه‌ها',
  'Claims & losses': 'خسارت و مفقودی',
  'Damage, loss and compensation': 'آسیب، مفقودی و غرامت',
  'Commercial & finance': 'بازرگانی و مالی',
  Quotes: 'پیشنهادهای قیمت (Quote)',
  'Pricing and customer offers': 'قیمت‌گذاری و پیشنهاد به مشتری',
  'Rate cards': 'نرخ‌نامه‌ها',
  'Contract and selling rates': 'نرخ‌های قراردادی و فروش',
  Customers: 'مشتریان',
  'Customer accounts and contacts': 'حساب‌ها و مخاطبان مشتری',
  Invoices: 'صورتحساب‌ها',
  'Billing and settlement': 'صدور صورتحساب و تسویه',
  'COD ledger': 'دفتر پرداخت در محل (COD)',
  'Cash collection and discrepancy': 'دریافت وجه و مغایرت‌ها',
  Insights: 'بینش مدیریتی',
  'Operations & finance': 'عملیات و مالی',
  'Essential management KPIs': 'شاخص‌های ضروری مدیریت',
  'Sales report': 'گزارش فروش',
  'Sales and profit overview': 'نمای کلی فروش و سود',
  'Management reports': 'گزارش‌های مدیریتی',
  'Order & waybill status': 'وضعیت سفارش و بارنامه',
  'Revenue & shipping cost': 'درآمد و هزینه حمل',
  'Payment & settlement': 'پرداخت و تسویه',
  'Customer performance': 'عملکرد مشتری',
  'Popular routes': 'مسیرهای پرتردد',
  'Volume & weight': 'حجم و وزن',
  'Charts & analytics': 'نمودارها و تحلیل‌ها',
  'Shipment pipeline': 'قیف محموله‌ها',
  'Revenue trend': 'روند درآمد',
  'Route performance': 'عملکرد مسیر',
  'Customer analytics': 'تحلیل مشتریان',
  'Flight report': 'گزارش پرواز',
  'Special cargo': 'بار ویژه',
  'Detailed reports': 'گزارش‌های تفصیلی',
  'Daily traffic & revenue': 'ترافیک و درآمد روزانه',
  'Service comparison': 'مقایسه سرویس‌ها',
  'Stalled counter traffic': 'ترافیک باجه‌های متوقف',
  'COD service revenue': 'درآمد سرویس پرداخت در محل (COD)',
  'Traffic, revenue & average rate': 'ترافیک، درآمد و میانگین نرخ',
  'Customs stock': 'موجودی گمرک',
  'Daily performance': 'عملکرد روزانه',
  'Shipment trend': 'روند محموله‌ها',
  'International trend': 'روند بین‌المللی',
  'Traffic by package': 'ترافیک بر اساس بسته',
  'Traffic by province': 'ترافیک بر اساس استان',
  'Weight frequency': 'توزیع وزن',
  Redistribution: 'توزیع مجدد',
  'Postal & national code': 'کد پستی و کد ملی',
  'Expired delivery': 'تحویل خارج از تعهد',
  'Distribution status': 'وضعیت توزیع',
  'Non-distribution reasons': 'دلایل عدم توزیع',
  'Delivered percentage': 'درصد تحویل‌شده',
  Administration: 'مدیریت سیستم',
  'Company settings': 'تنظیمات شرکت',
  'Brand, rules and feature settings': 'برند، قوانین و قابلیت‌ها',
  'System health': 'سلامت سیستم',
  'Services, queue and failures': 'سرویس‌ها، صف و خطاها',
  'Users & partners': 'کاربران و همکاران',
  Administrators: 'مدیران',
  Agents: 'نمایندگان',
  Airlines: 'شرکت‌های هواپیمایی',
  Agencies: 'آژانس‌ها',
  Locations: 'مکان‌ها',
  'Base locations': 'مکان‌های پایه',
  Countries: 'کشورها',
  Cities: 'شهرها',
  'Master data': 'اطلاعات پایه',
  Services: 'سرویس‌ها',
  Packaging: 'بسته‌بندی',
  'Tracking statuses': 'وضعیت‌های رهگیری',
  'Payment methods': 'روش‌های پرداخت',
  Currencies: 'ارزها',
  'Carrying terms': 'شرایط حمل',
  Notes: 'یادداشت‌ها',

  // Shipment and freight terminology
  Shipment: 'محموله',
  Order: 'سفارش',
  Orders: 'سفارش‌ها',
  Reference: 'مرجع',
  References: 'مراجع',
  Package: 'بسته',
  Packages: 'بسته‌ها',
  Parcel: 'پارسل',
  Commodity: 'کالا',
  'Chargeable weight': 'وزن قابل محاسبه',
  Cargo: 'کارگو',
  Courier: 'کوریر',
  Pickup: 'دریافت',
  Delivery: 'تحویل',
  Driver: 'راننده',
  Vehicle: 'وسیله نقلیه',
  Route: 'مسیر',
  Origin: 'مبدأ',
  Destination: 'مقصد',
  Sender: 'فرستنده',
  Recipient: 'گیرنده',
  Consignee: 'گیرنده',
  Shipper: 'فرستنده',
  Weight: 'وزن',
  Volume: 'حجم',
  Pieces: 'تعداد',
  Service: 'سرویس',
  Carrier: 'حمل‌کننده',
  Airline: 'شرکت هواپیمایی',
  Flight: 'پرواز',
  Booking: 'رزرو (Booking)',
  Manifest: 'مانیفست (Manifest)',
  'Console manifest': 'مانیفست کنسول (Manifest)',
  AWB: 'بارنامه هوایی (AWB)',
  MAWB: 'بارنامه اصلی هوایی (MAWB)',
  POD: 'مدرک تحویل (POD)',
  COD: 'پرداخت در محل (COD)',
  Tracking: 'رهگیری',
  Timeline: 'خط زمانی',
  Documents: 'اسناد',
  Document: 'سند',
  'Financial items': 'اقلام مالی',
  Invoice: 'صورتحساب',
  Rate: 'نرخ',
  Revenue: 'درآمد',
  Cost: 'هزینه',
  Profit: 'سود',
  Currency: 'ارز',
  Amount: 'مبلغ',
  Balance: 'مانده',
  Customs: 'گمرک',
  Clearance: 'ترخیص',
  Warehouse: 'انبار',
  'Dangerous goods': 'کالای خطرناک',
  Claim: 'پرونده خسارت',
  Claims: 'پرونده‌های خسارت',
  'In Transit': 'در حال حمل',
  'Ready for Pickup': 'آماده دریافت',
  'Picked Up': 'دریافت‌شده',
  'Received at Origin': 'دریافت در مبدأ',
  'Ready for Delivery': 'آماده تحویل',
  'Out for Delivery': 'در مسیر تحویل',
  Delivered: 'تحویل‌شده',
  'Delivery failed': 'تحویل ناموفق',
  Returned: 'مرجوع‌شده',
  'Customs hold': 'توقف در گمرک',
  'Customs released': 'ترخیص از گمرک',
  Departed: 'خارج‌شده',
  Arrived: 'واردشده',

  // Settings
  'Company Settings': 'تنظیمات شرکت',
  'Workspace configuration': 'پیکربندی فضای کاری',
  'Manage company identity, invoice details and the operational modules your team actually uses.':
    'هویت شرکت، اطلاعات صورتحساب و ماژول‌های عملیاتی موردنیاز تیم را مدیریت کنید.',
  'Loading settings': 'در حال بارگذاری تنظیمات',
  'Settings could not be loaded. Check your access and try again.':
    'تنظیمات بارگذاری نشد. دسترسی خود را بررسی و دوباره تلاش کنید.',
  Company: 'شرکت',
  'Company identity': 'هویت شرکت',
  'This information is used across printed documents and customer-facing pages.':
    'این اطلاعات در اسناد چاپی و صفحات قابل مشاهده برای مشتری استفاده می‌شود.',
  'Application name': 'نام نرم‌افزار',
  'Trade name': 'نام تجاری',
  'Company brand name': 'نام برند شرکت',
  'Legal company name': 'نام حقوقی شرکت',
  'Registered legal name': 'نام حقوقی ثبت‌شده',
  'National ID': 'شناسه ملی',
  'Registration number': 'شماره ثبت',
  'Economic code': 'کد اقتصادی',
  'Tax file number': 'شماره پرونده مالیاتی',
  Country: 'کشور',
  City: 'شهر',
  Address: 'آدرس',
  'Postal code': 'کد پستی',
  Phone: 'تلفن',
  Fax: 'فکس',
  'Public email': 'ایمیل عمومی',
  Website: 'وب‌سایت',
  'Tracking URL': 'آدرس رهگیری',
  'Support line': 'شماره پشتیبانی',
  'Finance email': 'ایمیل مالی',
  'Finance phone': 'تلفن مالی',
  'Operations email': 'ایمیل عملیات',
  'Operations phone': 'تلفن عملیات',
  'Bank name': 'نام بانک',
  'Account number': 'شماره حساب',
  IBAN: 'شماره شبا',
  'Company logo': 'لوگوی شرکت',
  'No logo selected': 'لوگویی انتخاب نشده است',
  'Choose logo': 'انتخاب لوگو',
  'Maximum file size: 2 MB.': 'حداکثر حجم فایل: ۲ مگابایت.',
  'Invoice settings': 'تنظیمات صورتحساب',
  'Base currency': 'ارز پایه',
  'Default tax rate': 'نرخ مالیات پیش‌فرض',
  'Minimum quote margin': 'حداقل حاشیه سود پیشنهاد قیمت',
  'Official invoices': 'صورتحساب رسمی',
  'Unofficial invoices': 'صورتحساب غیررسمی',
  'Show stamp on invoice': 'نمایش مهر روی صورتحساب',
  'Payment terms': 'شرایط پرداخت',
  'Invoice footer': 'پاورقی صورتحساب',
  'Invoice number pattern': 'الگوی شماره صورتحساب',
  'Order number pattern': 'الگوی شماره سفارش',
  'Quote number pattern': 'الگوی شماره پیشنهاد قیمت',
  'Manifest number pattern': 'الگوی شماره مانیفست (Manifest)',
  Modules: 'ماژول‌ها',
  'Operational modules': 'ماژول‌های عملیاتی',
  'Enable only the workflows used by this company.': 'فقط فرآیندهای مورد استفاده این شرکت را فعال کنید.',
  'Cargo workflow': 'فرآیند کارگو',
  'Courier workflow': 'فرآیند کوریر',
  'Quote management': 'مدیریت پیشنهاد قیمت',
  'Customs clearance': 'ترخیص گمرکی',
  'Warehouse scans': 'اسکن‌های انبار',
  'Dispatch management': 'مدیریت اعزام',
  'Cash on delivery': 'پرداخت در محل (COD)',
  'Dangerous goods handling': 'مدیریت کالای خطرناک',
  Notifications: 'اعلان‌ها',
  'Email notifications': 'اعلان ایمیلی',
  'SMS notifications': 'اعلان پیامکی',
  'Notification events': 'رویدادهای اعلان',
  'Notification log': 'گزارش اعلان‌ها',
  'No notification has been recorded yet.': 'هنوز اعلانی ثبت نشده است.',
  Preferences: 'ترجیحات',
  'Application preferences': 'ترجیحات نرم‌افزار',
  'Keep these defaults aligned with the company’s daily operation.':
    'این مقادیر پیش‌فرض را متناسب با عملیات روزانه شرکت تنظیم کنید.',
  'Default proof of delivery': 'روش پیش‌فرض مدرک تحویل (POD)',
  Signature: 'امضا',
  Photo: 'تصویر',
  'No proof required': 'بدون نیاز به مدرک',
  'Maximum delivery attempts': 'حداکثر دفعات تلاش برای تحویل',
  'Default retry fee': 'هزینه پیش‌فرض تلاش مجدد',
  'Applied only when Dispatch confirms the charge.': 'فقط پس از تأیید هزینه توسط واحد اعزام اعمال می‌شود.',
  'Default return fee': 'هزینه پیش‌فرض مرجوعی',
  'Applied only when Return to Sender is selected.': 'فقط هنگام انتخاب مرجوع به فرستنده اعمال می‌شود.',
  Timezone: 'منطقه زمانی',
  Language: 'زبان نرم‌افزار',
  Calendar: 'تقویم',
  English: 'انگلیسی',
  Persian: 'فارسی',
  Jalali: 'شمسی',
  Gregorian: 'میلادی',
  'Print footer': 'پاورقی چاپ',
  'About the company': 'درباره شرکت',
  'Changes are audited and apply after saving.': 'تغییرات ثبت و پس از ذخیره برای همه کاربران اعمال می‌شوند.',
  'Company settings saved and applied successfully.': 'تنظیمات شرکت با موفقیت ذخیره و اعمال شد.',
  'At least Cargo or Courier must remain enabled.': 'حداقل یکی از فرآیندهای کارگو یا کوریر باید فعال بماند.',
  'Language is applied to all company users after saving.': 'زبان پس از ذخیره برای تمام کاربران شرکت اعمال می‌شود.',
  'Calendar selection is independent from the application language.': 'نوع تقویم مستقل از زبان نرم‌افزار است.',

  // Authentication and common forms
  Login: 'ورود',
  'Sign in': 'ورود',
  'Sign out': 'خروج',
  Email: 'ایمیل',
  Password: 'رمز عبور',
  'Remember me': 'مرا به خاطر بسپار',
  'Forgot password?': 'رمز عبور را فراموش کرده‌اید؟',
  Welcome: 'خوش آمدید',
  User: 'کاربر',
  Users: 'کاربران',
  Role: 'نقش',
  Permission: 'دسترسی',
  Contact: 'مخاطب',
  Contacts: 'مخاطبان',
  Customer: 'مشتری',
  'Customer name': 'نام مشتری',
  'Phone number': 'شماره تلفن',
  Mobile: 'موبایل',
  'First name': 'نام',
  'Last name': 'نام خانوادگی',
  Select: 'انتخاب',
  'Select an option': 'یک گزینه انتخاب کنید',
  'Select date': 'انتخاب تاریخ',
  'Start date': 'تاریخ شروع',
  'End date': 'تاریخ پایان',
  'Created at': 'تاریخ ایجاد',
  'Updated at': 'تاریخ به‌روزرسانی',
  'Created by': 'ایجادکننده',
  'Assigned to': 'تخصیص به',
  Reason: 'دلیل',
  Note: 'یادداشت',
  Comments: 'توضیحات',
  Internal: 'داخلی',
  External: 'خارجی',
  Today: 'امروز',
  'This month': 'این ماه',
  Total: 'مجموع',
  Count: 'تعداد',
  Page: 'صفحه',
  'Rows per page': 'تعداد ردیف در صفحه',

  // Main operational screens
  'Open full workbench': 'بازکردن میز کار کامل',
  'Try again': 'تلاش دوباره',
  'Reference Number': 'شماره مرجع',
  'Created At': 'تاریخ ایجاد',
  'Latest Status': 'آخرین وضعیت',
  Price: 'مبلغ',
  Remainder: 'مانده',
  'Search shipments': 'جست‌وجوی محموله‌ها',
  'Search by ID': 'جست‌وجو بر اساس شناسه',
  'Sales Person': 'کارشناس فروش',
  'Search by Sales Person name': 'جست‌وجو بر اساس نام کارشناس فروش',
  Coordinator: 'هماهنگ‌کننده',
  'Search by Coordinator name': 'جست‌وجو بر اساس نام هماهنگ‌کننده',
  'Search by references Number': 'جست‌وجو بر اساس شماره مرجع',
  'Search by origin name': 'جست‌وجو بر اساس نام مبدأ',
  'Search by destination name': 'جست‌وجو بر اساس نام مقصد',
  'Search by tracking status': 'جست‌وجو بر اساس وضعیت رهگیری',
  'Is Valid': 'معتبر',
  'Search by Valid Status': 'جست‌وجو بر اساس اعتبار',
  'Search by Type': 'جست‌وجو بر اساس نوع',
  'Drivers & vehicles': 'رانندگان و وسایل نقلیه',
  'Dispatch summary': 'خلاصه اعزام',
  'Search reference, address or driver': 'جست‌وجوی مرجع، آدرس یا راننده',
  'Search pickup or delivery missions': 'جست‌وجوی مأموریت‌های دریافت یا تحویل',
  'All mission types': 'همه انواع مأموریت',
  'Filter by mission type': 'فیلتر بر اساس نوع مأموریت',
  Planning: 'برنامه‌ریزی',
  'Ready to plan and assign': 'آماده برنامه‌ریزی و تخصیص',
  'Driver routes': 'مسیرهای رانندگان',
  'Assigned routes and capacity': 'مسیرهای تخصیص‌یافته و ظرفیت',
  'Rejected receipt': 'دریافت ردشده',
  'Reject COD receipt': 'رد دریافت COD',
  'Reject receipt': 'رد دریافت',
  'Reason for rejection': 'دلیل رد',
  'COD receipt rejected': 'دریافت COD رد شد',
  'COD receipt rejected by finance.': 'دریافت COD توسط مالی رد شد.',
  'COD action saved.': 'اقدام COD ذخیره شد.',
  'Payment documents delivered to finance.': 'مدارک پرداخت به واحد مالی تحویل شد.',
  'All statuses': 'همه وضعیت‌ها',
  'Ready to plan': 'آماده برنامه‌ریزی',
  Unassigned: 'تخصیص‌نیافته',
  Assigned: 'تخصیص‌یافته',
  Accepted: 'پذیرفته‌شده',
  'En route': 'در مسیر',
  Arrived: 'رسیده',
  Failed: 'ناموفق',
  'Return to sender': 'بازگشت به فرستنده',
  'All drivers': 'همه رانندگان',
  'Filter by status': 'فیلتر بر اساس وضعیت',
  'Filter by driver': 'فیلتر بر اساس راننده',
  'Clear filters': 'پاک‌کردن فیلترها',
  'Failed deliveries awaiting a decision': 'تحویل‌های ناموفق در انتظار تصمیم',
  'ACTION REQUIRED': 'نیازمند اقدام',
  'No matching drivers': 'راننده‌ای مطابق فیلتر یافت نشد',
  'Try clearing the driver or status filter.': 'فیلتر راننده یا وضعیت را پاک کنید.',
  'Driver lanes': 'مسیرهای رانندگان',
  'Drag a mission onto a driver': 'مأموریت را روی راننده بکشید',
  'More details': 'جزئیات بیشتر',
  'Hide details': 'بستن جزئیات',
  'COD HISTORY': 'تاریخچه COD',
  'Confirmed collections': 'دریافت‌های تأییدشده',
  'Review COD receipts that have already been confirmed by finance.':
    'دریافت‌های COD که قبلاً توسط واحد مالی تأیید شده‌اند را بررسی کنید.',
  'Total confirmed': 'مجموع تأییدشده',
  'Showing on this page': 'نمایش در این صفحه',
  'Search order, driver or transaction': 'جست‌وجوی سفارش، راننده یا تراکنش',
  'No confirmed COD collections': 'دریافت COD تأییدشده‌ای وجود ندارد',
  'Confirmed receipts will appear here after finance approval.':
    'دریافت‌های تأییدشده پس از تأیید واحد مالی در اینجا نمایش داده می‌شوند.',
  Reassign: 'تخصیص مجدد',
  'Edit mission': 'ویرایش مأموریت',
  'Plan mission': 'برنامه‌ریزی مأموریت',
  'Failure reason summary': 'خلاصه دلایل عدم موفقیت',
  'Move stop up': 'انتقال توقف به بالا',
  'Move stop down': 'انتقال توقف به پایین',
  'Reason required': 'ثبت دلیل الزامی است',
  'Update status': 'به‌روزرسانی وضعیت',
  'Assignment history': 'تاریخچه تخصیص',
  'My Dispatch': 'اعزام‌های من',
  Sync: 'همگام‌سازی',
  'Synchronize assigned missions': 'همگام‌سازی مأموریت‌های تخصیص‌یافته',
  'Retry event': 'تلاش مجدد برای رویداد',
  'Discard event': 'حذف رویداد',
  'Mark all read': 'علامت‌گذاری همه به‌عنوان خوانده‌شده',
  'Loading missions': 'در حال بارگذاری مأموریت‌ها',
  'Operations Workbench': 'میز کار عملیات',
  'SLA rules': 'قوانین SLA',
  'SLA report': 'گزارش SLA',
  'Operational summary': 'خلاصه عملیات',
  'Shipment number or action': 'شماره محموله یا نوع اقدام',
  'All severities': 'همه شدت‌ها',
  'All owners': 'همه مسئولان',
  'Specific owner': 'مسئول مشخص',
  'Cargo & Courier': 'کارگو و کوریر',
  'Cargo and Courier': 'کارگو و کوریر',
  'All services': 'همه سرویس‌ها',
  'All branches': 'همه شعبه‌ها',
  'Any due time': 'هر زمان سررسید',
  'Save owner & deadlines': 'ذخیره مسئول و مهلت‌ها',
  'Scan or enter package code': 'بارکد بسته را اسکن یا وارد کنید',
  'Record scan': 'ثبت اسکن',
  'Resolve with result': 'حل و ثبت نتیجه',
  'Add operational exception': 'افزودن استثنای عملیاتی',
  'Create exception': 'ایجاد استثنا',
  'Resolve exception': 'حل استثنا',
  Resolve: 'حل‌کردن',
  'New rule': 'قانون جدید',
  'Save SLA rule': 'ذخیره قانون SLA',
  'SLA compliance report': 'گزارش پایبندی به SLA',
  'Run report': 'اجرای گزارش',
  'New quote': 'پیشنهاد قیمت جدید',
  'Quote number or customer': 'شماره پیشنهاد قیمت یا مشتری',
  'All shipment types': 'همه انواع محموله',
  'All statuses': 'همه وضعیت‌ها',
  Quote: 'پیشنهاد قیمت (Quote)',
  Margin: 'حاشیه سود',
  'Quote form steps': 'مراحل فرم پیشنهاد قیمت',
  'Select customer': 'انتخاب مشتری',
  'Select contact': 'انتخاب مخاطب',
  'Select origin': 'انتخاب مبدأ',
  'Select destination': 'انتخاب مقصد',
  'Select service': 'انتخاب سرویس',
  'Any airline': 'هر شرکت هواپیمایی',
  'Select product': 'انتخاب نوع کالا',
  'Carton, pallet, bag…': 'کارتن، پالت، کیسه و ...',
  'Save & find rate': 'ذخیره و یافتن نرخ',
  'Apply this rate': 'اعمال این نرخ',
  'Select currency': 'انتخاب ارز',
  'What changed?': 'چه چیزی تغییر کرده است؟',
  'Save draft': 'ذخیره پیش‌نویس',
  'Customer approval link': 'لینک تأیید مشتری',
  'New rate': 'نرخ جدید',
  'Code or name': 'کد یا نام',
  'All rate types': 'همه انواع نرخ',
  Scope: 'دامنه',
  'Sale / purchase': 'فروش / خرید',
  Validity: 'اعتبار',
  'Add charge': 'افزودن هزینه',
  'Charge name': 'عنوان هزینه',
  'Save rate': 'ذخیره نرخ',
  'Import rate cards': 'ورود نرخ‌نامه‌ها',
  'Confirm import': 'تأیید ورود اطلاعات',
  'Keyword Search': 'جست‌وجوی کلیدواژه',
  'Search by Reference number': 'جست‌وجو بر اساس شماره مرجع',
  'Search by Customer name': 'جست‌وجو بر اساس نام مشتری',
  'Company Name': 'نام شرکت',
  'Search by Customer company name': 'جست‌وجو بر اساس نام شرکت مشتری',
  'Search by Price': 'جست‌وجو بر اساس مبلغ',
  'Search by Remainder': 'جست‌وجو بر اساس مانده',
  Official: 'رسمی',
  'Search by Offical': 'جست‌وجو بر اساس رسمی‌بودن',
  'Paid Status': 'وضعیت پرداخت',
  'Search by Paid Status': 'جست‌وجو بر اساس وضعیت پرداخت',
  'Search by Status': 'جست‌وجو بر اساس وضعیت',
  'Search by date': 'جست‌وجو بر اساس تاریخ',
  'Claims & Losses': 'خسارت و مفقودی',
  'New claim': 'پرونده خسارت جدید',
  'Claims summary': 'خلاصه خسارت‌ها',
  'Claim or shipment number': 'شماره خسارت یا محموله',
  'All claim types': 'همه انواع خسارت',
  Issue: 'موضوع',
  Owner: 'مسئول',
  Deadline: 'مهلت',
  'Open claim': 'بازکردن پرونده خسارت',
  'Edit claim': 'ویرایش پرونده خسارت',
  'Register claim': 'ثبت پرونده خسارت',
  'Whole shipment': 'کل محموله',
  'Claim details': 'جزئیات پرونده خسارت',
  'Change status': 'تغییر وضعیت',
  'Change claim status': 'تغییر وضعیت پرونده خسارت',
  'Confirm status': 'تأیید وضعیت',
  'Operational Manifests': 'مانیفست‌های عملیاتی (Manifest)',
  'Create Manifest': 'ایجاد مانیفست (Manifest)',
  'Search manifest, MAWB or flight': 'جست‌وجوی مانیفست، MAWB یا پرواز',
  'All types': 'همه انواع',
  'Main AWB': 'بارنامه اصلی هوایی (MAWB)',
  'Gross kg': 'وزن ناخالص (کیلوگرم)',
  'Chargeable kg': 'وزن قابل محاسبه (کیلوگرم)',
  Manage: 'مدیریت',
  'Edit information': 'ویرایش اطلاعات',
  Reopen: 'بازگشایی',
  'Export PDF': 'خروجی PDF',
  'Export Excel': 'خروجی Excel',
  'Shipment number or ID': 'شماره یا شناسه محموله',
  'Bag number (optional)': 'شماره کیسه (اختیاری)',
  Workflow: 'فرآیند',
  Bag: 'کیسه',
  'Remove shipment': 'حذف محموله',
  'Add extra': 'افزودن مورد اضافی',
  'Note for mismatch': 'توضیح مغایرت',
  'Remove extra row': 'حذف ردیف اضافی',
  'Complete reconciliation': 'تکمیل تطبیق',
  'Edit manifest information': 'ویرایش اطلاعات مانیفست (Manifest)',
  'Required when sensitive transport information changes': 'هنگام تغییر اطلاعات حساس حمل، ثبت این مورد الزامی است',
  'Reopen manifest': 'بازگشایی مانیفست (Manifest)',
  'Cancel manifest': 'لغو مانیفست (Manifest)',
  Features: 'قابلیت‌ها',
  'Driver dispatch': 'اعزام راننده',
  'Show stamp': 'نمایش مهر',
  'Select operational events': 'انتخاب رویدادهای عملیاتی',
  'Carrier integrations': 'یکپارچه‌سازی حمل‌کنندگان',
  'Copy secret': 'کپی کلید محرمانه',
  'Create connector': 'ایجاد اتصال',
  'Rotate secret': 'تغییر کلید محرمانه',
  WORKSPACE: 'فضای کاری',
  'Good day, {name}': 'روز بخیر، {name}',
  'Start with the items that need attention, then continue your daily work.':
    'ابتدا موارد نیازمند رسیدگی را بررسی کنید و سپس کارهای روزانه را ادامه دهید.',
  'Open operations': 'ورود به عملیات',
  'Quick actions': 'دسترسی سریع',
  'Your most common starting points.': 'مسیرهای پرکاربرد برای شروع کار.',
  'View and manage parcels': 'مشاهده و مدیریت مرسوله‌ها',
  'View and manage freight': 'مشاهده و مدیریت بار',
  'Plan pickup and delivery': 'برنامه‌ریزی جمع‌آوری و تحویل',
  'Prepare and follow up quotes': 'ثبت و پیگیری پیش‌فاکتورها',
  'Today at a glance': 'خلاصه امروز',
  'Four operational numbers, without the reporting noise.': 'چهار شاخص اصلی عملیات، بدون اطلاعات اضافی.',
  'View reports': 'مشاهده گزارش‌ها',
  "Today's orders": 'سفارش‌های امروز',
  'Delivered today': 'تحویل‌شده امروز',
  'In transit': 'در حال حمل',
  Undelivered: 'تحویل‌نشده',
  "Loading today's summary…": 'در حال دریافت خلاصه امروز…',
  "Today's summary could not be loaded.": 'خلاصه امروز دریافت نشد.',
  'Needs attention': 'نیازمند رسیدگی',
  'Open risks ordered by urgency and due time.': 'ریسک‌های باز به‌ترتیب فوریت و مهلت رسیدگی.',
  'Operational actions could not be loaded.': 'اقدامات عملیاتی دریافت نشد.',
  'Nothing needs attention.': 'موردی نیازمند رسیدگی نیست.',
  'Current shipments are within their configured controls.':
    'مرسوله‌های جاری در محدوده کنترل‌های تعریف‌شده قرار دارند.',
  'Recent shipments': 'مرسوله‌های اخیر',
  'Continue where the team left off.': 'کار را از آخرین فعالیت تیم ادامه دهید.',
  'Reference number': 'شماره مرجع',
  'Created at': 'تاریخ ایجاد',
  'Latest status': 'آخرین وضعیت',
  'No recent shipment was found.': 'مرسوله اخیری یافت نشد.',
  'Management workspace': 'فضای کاری مدیریت',
  'Sales workspace': 'فضای کاری فروش',
  'Finance workspace': 'فضای کاری مالی',
  'Pickup & delivery workspace': 'فضای کاری جمع‌آوری و تحویل',
  'Operations workspace': 'فضای کاری عملیات',
  'Monitor operations, financial exposure and the items that need attention.':
    'عملیات، تعهدات مالی و موارد نیازمند رسیدگی را پایش کنید.',
  'Follow up quotes, customers and shipments that affect today’s sales.':
    'پیش‌فاکتورها، مشتریان و مرسوله‌های مؤثر بر فروش امروز را پیگیری کنید.',
  'Focus on revenue, unpaid orders, invoices and settlement work.':
    'بر درآمد، سفارش‌های پرداخت‌نشده، فاکتورها و تسویه‌ها تمرکز کنید.',
  'See today’s missions, delayed work and shipments currently in motion.':
    'مأموریت‌های امروز، کارهای تأخیردار و مرسوله‌های در حال حرکت را مشاهده کنید.',
  'Start with the items that need attention, then continue daily operations.':
    'ابتدا موارد نیازمند رسیدگی را بررسی کنید و سپس عملیات روزانه را ادامه دهید.',
  'Operations workbench': 'میزکار عملیات',
  'Review urgent exceptions': 'بررسی استثناهای فوری',
  'Review billing and settlement': 'بررسی صورتحساب و تسویه',
  'Report center': 'مرکز گزارش‌ها',
  'Back to report center': 'بازگشت به مرکز گزارش‌ها',
  'Reports available': 'گزارش‌های در دسترس',
  'Visible results': 'نتایج قابل نمایش',
  'Search in this category': 'جست‌وجو در این دسته',
  'Search in this category...': 'جست‌وجو در این دسته...',
  'Select a report to open its details': 'برای مشاهده جزئیات، یک گزارش را انتخاب کنید',
  Report: 'گزارش',
  'No reports available': 'گزارشی در دسترس نیست',
  'Try another report name.': 'نام گزارش دیگری را جست‌وجو کنید.',
  'There are no reports in this category for your access level.':
    'در این دسته گزارشی متناسب با سطح دسترسی شما وجود ندارد.',
  'Report category not found': 'دسته گزارش پیدا نشد',
  'Shipment flow and conversion stages': 'جریان محموله و مراحل تبدیل',
  'Flight and air waybill performance': 'عملکرد پرواز و بارنامه هوایی',
  'Special cargo volume and revenue': 'حجم و درآمد بار ویژه',
  'Route segments and revenue comparison': 'مقایسه مسیرها و درآمد',
  'Revenue and order trend over time': 'روند درآمد و تعداد سفارش در طول زمان',
  'Customer orders and revenue comparison': 'مقایسه سفارش‌ها و درآمد مشتریان',
  'Order and waybill status overview': 'نمای کلی وضعیت سفارش و بارنامه',
  'Shipment volume, weight and package count': 'حجم، وزن و تعداد بسته‌های محموله',
  'Revenue and shipping cost overview': 'نمای کلی درآمد و هزینه حمل',
  'Payment and settlement status': 'وضعیت پرداخت و تسویه',
  'Customer shipment performance': 'عملکرد ارسال محموله‌های مشتریان',
  'Most used shipment routes': 'پرتکرارترین مسیرهای ارسال',
  'Organizational reports': 'گزارش‌های سازمان',
  'Persian-language reports for organizational workflows and operations.': 'گزارش‌های فارسی سازمان و عملیات.',
  'Chart reports': 'گزارش‌های نموداری',
  'Reports presented as charts for visual analysis.': 'گزارش‌هایی که برای تحلیل بصری به شکل نمودار نمایش داده می‌شوند.',
  'Useful reports': 'گزارش‌های کاربردی',
  'Frequently used operational, financial and management reports.': 'گزارش‌های پرکاربرد عملیاتی، مالی و مدیریتی.',
  'Open management insights': 'مشاهده تحلیل‌های مدیریتی',
  'Open customer accounts': 'مشاهده حساب مشتریان',
  'Follow up customer invoices': 'پیگیری فاکتورهای مشتریان',
  'Review cash-on-delivery balances': 'بررسی مانده پرداخت در محل',
  'Review quote financials': 'بررسی اطلاعات مالی پیش‌فاکتورها',
  'Open financial reports': 'مشاهده گزارش‌های مالی',
  'My dispatch': 'مأموریت‌های من',
  'Open assigned missions': 'مشاهده مأموریت‌های تخصیص‌یافته',
  'Review pickups waiting to start': 'بررسی جمع‌آوری‌های در انتظار',
  'View shipment details': 'مشاهده جزئیات مرسوله',
  'Waybills today': 'بارنامه‌های امروز',
  'Unpaid orders': 'سفارش‌های پرداخت‌نشده',
  'REPORT CENTER': 'مرکز گزارش‌ها',
  'Find the report you need': 'گزارش موردنظر را پیدا کنید',
  'Operational, commercial and management reports are organized in one searchable workspace.':
    'گزارش‌های عملیاتی، تجاری و مدیریتی در یک فضای قابل جست‌وجو سازمان‌دهی شده‌اند.',
  'Search reports': 'جست‌وجوی گزارش‌ها',
  'Search reports...': 'جست‌وجوی گزارش‌ها...',
  'Clear report search': 'پاک کردن جست‌وجوی گزارش',
  'Report categories': 'دسته‌بندی گزارش‌ها',
  'All reports': 'همه گزارش‌ها',
  Overview: 'نمای کلی',
  'Management summaries and cross-functional performance.': 'خلاصه‌های مدیریتی و عملکرد بین‌واحدی.',
  'Shipment status, routes, delivery and handling.': 'وضعیت مرسوله، مسیرها، تحویل و جابه‌جایی.',
  'Revenue, payments, service and customer performance.': 'درآمد، پرداخت‌ها، خدمات و عملکرد مشتریان.',
  'Specialized, statistical and compliance analysis.': 'تحلیل‌های تخصصی، آماری و انطباق.',
  'No report found': 'گزارشی یافت نشد',
  'Try another report name or select a different category.': 'نام دیگری جست‌وجو کنید یا دسته متفاوتی را انتخاب کنید.',
  'Clear filters': 'پاک کردن فیلترها',
  'Find all operational and business reports': 'یافتن همه گزارش‌های عملیاتی و تجاری',
  'Open global search': 'باز کردن جست‌وجوی سراسری',
  'Global search': 'جست‌وجوی سراسری',
  'Search workspace': 'جست‌وجوی فضای کاری',
  'Search pages, shipments or customers...': 'جست‌وجوی صفحه، مرسوله یا مشتری...',
  'Searching workspace…': 'در حال جست‌وجوی فضای کاری…',
  Pages: 'صفحات',
  'Recent pages': 'صفحات اخیر',
  Shipments: 'مرسوله‌ها',
  'No result found': 'نتیجه‌ای یافت نشد',
  'Try a page name, reference number or customer name.': 'نام صفحه، شماره مرجع یا نام مشتری را جست‌وجو کنید.',
  Navigate: 'پیمایش',
  Open: 'باز کردن',
  'Unpin page': 'برداشتن سنجاق صفحه',
  'Pin page': 'سنجاق کردن صفحه',
  'Recently visited': 'اخیراً مشاهده‌شده',
  'Pinned by you': 'سنجاق‌شده توسط شما',
  'Continue from your latest workspace activity.': 'کار را از آخرین فعالیت خود ادامه دهید.'
};

export default faMessages;
